import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withMemo as _withMemo, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-raleway-20 t-blue mb-2 mr-3 title-details" }
const _hoisted_2 = { class: "d-flex account-details a-i-center j-content-center" }
const _hoisted_3 = { class: "double-select mr-2 account-detail" }
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = { class: "uppercase text-raleway-13" }
const _hoisted_6 = { class: "input-wrapper account-create" }
const _hoisted_7 = { class: "uppercase text-raleway-13" }
const _hoisted_8 = { class: "double-select account-detail" }
const _hoisted_9 = { class: "input-wrapper account-manager" }
const _hoisted_10 = { class: "uppercase text-raleway-13" }
const _hoisted_11 = { class: "input-wrapper account-payment" }
const _hoisted_12 = { class: "uppercase text-raleway-13" }
const _hoisted_13 = { class: "mt-2 mb-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

import { AccountDetailsComponent } from "@/store/modules/accountDetails/type";
import { ErrorMessage, Field, useForm } from "vee-validate";
import { Costumers } from "@/store/modules/Customers/type";
import { IStore } from "@/store/types/StoreType";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";

import { UserTypeOperation } from "@/store/modules/User/type";
import { formatDate } from "@/utils/normileze/date";
import { fetchAll } from "../fetchData/fetchAll";


export default /*#__PURE__*/_defineComponent({
  __name: 'accountDetailsComponent',
  setup(__props) {

const store = useStore<IStore>();

const errorValues = ref();
const allErrors = ref();

watch(
  () => store.getters?.getGlobalErrorsAccountDetails || [],
  (value) => {
    allErrors.value = value;
    errorValues.value = allErrors.value.map((value: any) =>
      Array.isArray(Object.keys(value))
        ? Object.keys(value)[0]
        : Object.keys(value)
    );
  },
  {
    deep: true,
  }
);

const userData = ref(
  computed<UserTypeOperation>(() => store.getters.getUserData)
);
const customer = ref(
  computed<Costumers[]>(() => store.getters.getUserCustomerData)
);

const initialValues = ref<AccountDetailsComponent>(
  store.getters.getAccountComponentValuesAccountDetails
);

const { meta, errors, values, resetForm, validate } =
  useForm<AccountDetailsComponent>({
    initialValues,
    validationSchema: {},
  });

const finaly = inject<any>("FINALY");
const addForm = inject<any>("ADD_FORM");

addForm({
  position: 5,
  meta,
  errors,
  values,
  validate,
  resetForm,
  initialValues,
});

finaly({
  finaly: fetchAll,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "wrapper-details-data b-none",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(validate)()), ["prevent"]))
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$tc("account_details")), 1),
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("ID")), 1),
          _withMemo([userData.value?.id || []], () => _createVNode(_unref(Field), {
            maxlength: "30",
            type: "text",
            name: "id",
            class: "input input-mini mb-1",
            disabled: "",
            placeholder: userData.value?.id || _ctx.$tc('Not found')
          }, null, 8, ["placeholder"]), _cache, 0),
          _createVNode(_unref(ErrorMessage), {
            name: "id",
            class: "text text-raleway-13 error pointer t-danger"
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tc("Date of creation")), 1),
          _withMemo([(customer.value || [])[0]?.creation_time || []], () => _createVNode(_unref(Field), {
            maxlength: "30",
            type: "text",
            name: "creation_time",
            class: "input input-mini mb-1",
            disabled: "",
            placeholder: 
              ((customer.value || [])[0]?.creation_time &&
                _unref(formatDate)((customer.value || [])[0]?.creation_time, '-', false)) ||
              'Auto create'
            
          }, null, 8, ["placeholder"]), _cache, 1),
          _createVNode(_unref(ErrorMessage), {
            name: "creation_time",
            class: "text text-raleway-13 error pointer t-danger"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$tc("responsible manager")), 1),
          _withMemo([(customer.value || [])[0]?.sales_person_name], () => _createVNode(_unref(Field), {
            maxlength: "30",
            type: "text",
            name: "manager",
            class: "input input-mini mb-1",
            placeholder: 
              (customer.value || [])[0]?.sales_person_name || _ctx.$tc('Manager')
            ,
            disabled: ""
          }, null, 8, ["placeholder"]), _cache, 2),
          _createVNode(_unref(ErrorMessage), {
            name: "manager",
            class: "text text-raleway-13 error pointer t-danger"
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$tc("Payment form")), 1),
          _withMemo([], () => _createVNode(_unref(Field), {
            maxlength: "30",
            type: "text",
            name: "login",
            class: "input input-mini mb-1",
            placeholder: 
              (customer.value || [])[0]?.payment_type
                ? (customer.value || [])[0]?.payment_type?.toLocaleLowerCase() ===
                  'PREPAYMENT'.toLocaleLowerCase()
                  ? _ctx.$tc('Post payment')
                  : _ctx.$tc('Prepayment')
                : ''
            ,
            disabled: ""
          }, null, 8, ["placeholder"]), _cache, 3),
          _createVNode(_unref(ErrorMessage), {
            name: "login",
            class: "text text-raleway-13 error pointer t-danger"
          })
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allErrors.value, (error) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "uppercase text-raleway-13 t-danger text-center",
          key: error
        }, [
          (typeof error === 'object')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(Object.keys(error) + ": " + Object.values(error)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(error), 1))
        ]))
      }), 128))
    ], 512), [
      [_vShow, allErrors.value]
    ])
  ], 32))
}
}

})